var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/img/IconZOHome.jsx";

import React from 'react';
import PropTypes from 'prop-types';

var IconZOHome = function IconZOHome(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -3 51 59",
    width: "54",
    height: "54",
    className: className,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#ffffff",
    cx: "25",
    cy: "25",
    r: "28",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#136ffb",
    d: "M46.344,38.434c2.381-1.749,2.333-5.915-1.051-6.772.655.165,2.707-2.934.906-5.585-1.417-2.086-5.066-1.561-6.782-.043a6.764,6.764,0,0,0-2.106,5.951l.555,3.744a4.3,4.3,0,0,0,1.041,2.7",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#136ffb",
    points: "29.876 7.262 17.132 19.696 42.621 19.696 29.876 7.262",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#136ffb",
    x: "17.132",
    y: "7.262",
    width: "12.745",
    height: "9.572",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#c1edfe",
    x: "7.303",
    y: "19.696",
    width: "22.92",
    height: "18.802",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0c4499",
    x: "17.758",
    y: "20.531",
    width: "23.662",
    height: "17.967",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#136ffb",
    x: "17.758",
    y: "19.696",
    width: "12.17",
    height: "18.802",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    x: "10.007",
    y: "30.97",
    width: "4.804",
    height: "7.527",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    x: "19.04",
    y: "30.97",
    width: "3.6",
    height: "5.654",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    x: "25.046",
    y: "30.97",
    width: "3.6",
    height: "5.654",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#136ffb",
    x: "32.331",
    y: "30.97",
    width: "2.926",
    height: "5.654",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#136ffb",
    x: "37.212",
    y: "30.97",
    width: "2.926",
    height: "5.654",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#136ffb",
    x: "32.331",
    y: "22.583",
    width: "2.926",
    height: "5.654",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#136ffb",
    x: "37.212",
    y: "22.583",
    width: "2.926",
    height: "5.654",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    x: "19.04",
    y: "22.583",
    width: "9.607",
    height: "5.654",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    x: "8.411",
    y: "22.583",
    width: "3.192",
    height: "5.654",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    x: "13.214",
    y: "22.583",
    width: "3.192",
    height: "5.654",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "17.132 7.262 4.387 19.696 29.876 19.696 17.132 7.262",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c1edfe",
    points: "17.132 10.107 7.303 19.696 26.96 19.696 17.132 10.107",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#136ffb",
    x: "29.943",
    y: "19.696",
    width: "13.263",
    height: "1.671",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    x: "16.68",
    y: "19.696",
    width: "14.041",
    height: "1.671",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c4499",
    d: "M8.54,34.351a1.194,1.194,0,0,0-1.861.105,2.811,2.811,0,0,0-.6,1.393c.06-1.488.025-4.963-1.736-4.915-1.29.035-1.4,3.286-1.37,4.85-.486-1.636-1.124-2.386-2.041-2.4-2.254-.031.3,5.011.3,5.011l2.776.066,3.094.072c.184,0,.725-1.054.83-1.23a7.763,7.763,0,0,0,.7-1.35,2.148,2.148,0,0,0,.109-1.128A1.234,1.234,0,0,0,8.54,34.351Z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 9
    }
  }));
};

IconZOHome.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string
} : {};
IconZOHome.defaultProps = {
  className: null
};
export default IconZOHome;